import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { API } from "aws-amplify";

import { alert, stateAlert } from "../../../Store/simulate/actions";

import ModalFiltering from "../../../Components/FormElements/ModalFiltering";
import Button from "../../../Components/FormElements/Button";

import IconClose from "../../../Resources/svg/Icons/IconClose";

const ModalEmision = ({
  isOpen,
  setStateEmision,
  modalData,
  getQuotes,
}: any) => {
  const dispatch = useDispatch();
  const { handleSubmit, register, reset } = useForm();
  const { idCotizacion } = modalData;

  const [loadingClick, setLoadingClick] = useState<any>(false);

  const onSubmit = async (data: any) => {
    const { emision } = data;
    setLoadingClick(true);

    try {
      const payloadEmision = {
        body: {
          idCotizacion: idCotizacion,
          motivoEmisionManual: emision,
        },
      };
      const response = await API.post(
        "api-rentas",
        "/activacion-manual",
        payloadEmision
      );
      if (response.status) {
        setLoadingClick(false);
        dispatch(stateAlert(true));
        dispatch(
          alert({
            type: "success",
            title: "¡Emisión enviada!",
            message: `Se ha enviado correctamente la emisión manual.`,
          })
        );

        setTimeout(() => {
          dispatch(stateAlert(false));
        }, 4000);

        getQuotes();
        handleClose();

        // setParams({
        //   page: 1,
        //   limit: 6,
        //   state: "pendiente",
        //   codProd: "IG",
        //   haveKey: false,
        //   keyPage: null,
        // });
      }
    } catch (error) {
      setLoadingClick(false);
    }
  };

  const radioInputs = [
    {
      id: "falla",
      value: "Falla biométrica",
      text: "Falla biométrica",
      active: true,
    },
    {
      id: "ri",
      value: "Más de un RI",
      text: "Más de un RI",
      active: false,
    },
    {
      id: "firma",
      value: "Firma a mano",
      text: "Firma a mano",
      active: false,
    },
    {
      id: "rescate",
      value: "Rescate con Renovación",
      text: "Rescate con Renovación",
      active: false,
    },
  ];

  const handleClose = () => {
    const datos: any = {
      emision: "Falla biométrica"
    };
    reset(datos);
    setStateEmision(false);
  };

  return (
    <div className="modal-rechazar">
      <ModalFiltering
        className={`modal-result is-midle ${isOpen && "is-open"}`}
        variant={true}
      >
        <div className="modal-filtering__close" onClick={handleClose}>
          <IconClose />
        </div>
        <h2 className="modal-result__title">
          ¿Estás seguro que deseas activar el proceso manual?
        </h2>
        <div className="modal-result__content">
          <div className="modal-result__subtitle">
            Selecciona el motivo por el cual harás la selección manual.
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          {radioInputs.map(({ id, value, text, active }) => (
            <div className="radio-box" key={id}>
              <label>
                <input
                  className="with-gap"
                  name="emision"
                  id={id}
                  type="radio"
                  value={value}
                  ref={register()}
                  defaultChecked={active}
                />
                <span>{text}</span>
              </label>
            </div>
          ))}
          <div className="actions">
            <Button
              type="submit"
              className={`${
                loadingClick ? "is-loading" : ""
              } actions__continue`}
              onClick={onSubmit}
            >
              Sí, activar
            </Button>
            <Button
              type="button"
              className="is-secondary actions__cancel"
              onClick={handleClose}
              disabled={loadingClick ? true : false}
            >
              Cancelar
            </Button>
          </div>
        </form>
      </ModalFiltering>
    </div>
  );
};

export default ModalEmision;
